import "./styles/ServiceAreas.css";
import { Link } from "react-router-dom";
import SEO from "./SEO";
import { CITY_PAGES, cityPath } from "./cityPages";

function ServiceAreas() {
    return (
        <div>
            <SEO
                path="/serviceareas"
                title="Appliance Repair Service Areas in Illinois | AT Appliance Repair"
                description="We repair appliances in Plainfield, Naperville, Bolingbrook, Orland Park, Schaumburg and 30+ other Illinois suburbs. Call (331) 600-4935."
            />

            <div className="background_image2">
                <h1 className="servicearea_title">Professional Appliance Repair Service in Your Area</h1>
                <p className="paragraph-4">If you live in the Chicago suburbs, our appliance repair services are perfect for you! Our experienced technicians provide quality workmanship and swift solutions to ensure that your appliances are back up and running as quickly as possible. Plus, we offer fair prices and guarantee customer satisfaction with every job, so you can trust us to do the job right. <Link to="/contact">Contact us today</Link> to find out how our appliance repair services can help you!</p>
            </div>

            <p className="countty">Illinois</p>

            {/* All 36 links come from cityPages.js, so none can point to a wrong URL */}
            <div className="wrapper">
                {CITY_PAGES.map(({ slug, name }) => (
                    <Link key={slug} to={cityPath(slug)} className="area-link w-inline-block">
                        <div className="icon-txt-2"></div>
                        <h3 className="area-h3">{name}, IL</h3>
                    </Link>
                ))}
            </div>

            {/* Trust badges removed: they were loaded from another company's site.
                The duplicate "Satisfaction Guaranteed" and Covid-19 blocks were also removed
                (they live on the home page). */}

            <div className="grid-container-2">
                <h2 className="contact-text">Headquarters</h2>
                <p>Plainfield, IL 60586</p>
                <h2 className="contact-text">Contact Information</h2>
                <p className="contact-info">Please don’t hesitate to contact us about all of your appliance repair needs. We will be happy to schedule a convenient appointment for you and our experienced technician.</p>
                <p className="contact-info"><strong><a href="tel:+13316004935">(331) 600-4935</a></strong></p>
                <p><a href="mailto:altantransit@gmail.com">altantransit@gmail.com</a></p>
                <div>
                    <h2 className="contact-text">Working Hours</h2>
                    <p className="contact-info">
                        Monday - Sunday:
                        <br />
                        8:00am - 9:00pm
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ServiceAreas;